import { createPricesFilterClickEvent } from '@/domain/prices/analytics/index';
import type { Option } from '@/domain/prices/filters/types';
import { useIntl } from '@/intl';
import MultiSelectPricesFilter, {
  mapLocalSelectionToGA4Result,
} from '@/react-pages/Prices/Filters/BaseFilter/MultiSelectPricesFilter';

export function DurationDropdownFilter() {
  const intl = useIntl();
  return (
    <MultiSelectPricesFilter
      type="Duration"
      label={intl.formatMessage({ id: 'prices_filters_durations_label' })}
      placeholder={intl.formatMessage({ id: 'prices_filters_durations_placeholder' })}
      confirmButton={intl.formatMessage({ id: 'quicksearch_save_button_text' })}
      icon="IconDuration"
      analyticsEventBuilder={(selection: string | string[] | undefined, options: Option[]) => {
        return createPricesFilterClickEvent({
          element: 'dropdown',
          type: 'duration',
          result: mapLocalSelectionToGA4Result(selection, options),
        });
      }}
    />
  );
}
